import { call, put } from 'redux-saga/effects';
import { iActionGetAll } from '~/domain/interfaces/redux/clinicalDocs/getAll';
import { GetAllClinicalDocs } from '~/domain/usecases/clinicalDocs/remote/GetAllClinicalDocs';
import { makeRemoteGetAllClinicalDocs } from '~/main/factories/usecases/clinicalDocs/GetAllClinicalDocsFactory';
import {
  getAllSuccess,
  getAllFailed,
} from '~/data/store/reducer/clinicalDocs/actions/getAll';

export function* onGetAll(action: iActionGetAll) {
  const remoteGetAllClinicalDocs = makeRemoteGetAllClinicalDocs();

  try {
    const response: GetAllClinicalDocs.Model = yield call(
      remoteGetAllClinicalDocs.getAll,
      action.payload,
    );

    yield put(getAllSuccess(response));
  } catch (e) {
    yield put(getAllFailed());
  }
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function onGetAllSuccess() {}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function onGetAllFailed() {}
